'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import a$1 from "../defs/File.es.js";
const o = a.forwardRef((r, t) => /* @__PURE__ */ a.createElement(p, { ref: t, ...r, weights: a$1 }));
o.displayName = "FileIcon";
const s = o;
export {
  s as File,
  o as FileIcon
};
